"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_emitter_1 = require("./event-emitter");
exports.EventEmitter = event_emitter_1.EventEmitter;
//# sourceMappingURL=index.js.map